<div class="flex">
  <!--  <button class="btn btn-primary" (click)="doInsert()">
    新增
  </button>
  <button class="btn btn-primary" (click)="doDelete()">
    刪除
  </button> -->
  <!--   <button class="btn btn-primary" (click)="doParamSubmit()">
    確定參數修改
  </button>
  <button class="btn btn-primary" (click)="doParamCancel()">
    取消參數修改
  </button>
 -->
</div>
<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabDetail label="參數明細">
    <app-crudbar-nav #crudbar [title]="label()" (onReady)="onCrudbarReady($event)">
    </app-crudbar-nav>
    <mat-toolbar>
      <button class="btn-primary" (click)="doInsert()">新增</button>
      <span class="mx-2">|</span>
      <button class="btn-refresh" (click)="doRefresh()">重新整理</button>
      <span class="mx-2">|</span>
      <button class="btn-ok" (click)="doTableOk()">確定參數修改</button>
      <span class="mx-2">|</span>
      <button class="btn-cancel" (click)="doTableCancel()">取消參數修改</button>
    </mat-toolbar>
    <table mat-table [dataSource]="dataSource.data">
      <!-- Name Column -->
      <ng-container matColumnDef="btn">
        <th mat-header-cell *matHeaderCellDef> * </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;">
          <button mat-mini-button class="jk-button-small" (click)="doDelete(item.name)">刪</button>
        </td>
      </ng-container>
      <ng-container matColumnDef="caption">
        <th mat-header-cell *matHeaderCellDef> 條件名稱 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 200px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.caption" [width]="'60'">
          </app-jkedit>
        </td>
      </ng-container>
      <ng-container matColumnDef="text">
        <th mat-header-cell *matHeaderCellDef> 條件值 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 200px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.text">
          </app-jkedit>
        </td>
      </ng-container>
      <ng-container matColumnDef="kind">
        <th mat-header-cell *matHeaderCellDef> 元件型式 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 160px;">
          <app-jkcombobox class="jk-combobox-border" [styleDisplay]="'flex'" label="" [(value)]="item.kind"
            [items]="jobParamKindList">
          </app-jkcombobox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> 元件名稱 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 120px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.name">
          </app-jkedit>
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> 資料類型 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 120px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.type">
          </app-jkedit>
        </td>
      </ng-container>
      <ng-container matColumnDef="ps">
        <th mat-header-cell *matHeaderCellDef> 說明 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 200px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.ps">
          </app-jkedit>
        </td>
      </ng-container>
      <ng-container matColumnDef="ps2">
        <th mat-header-cell *matHeaderCellDef> 說明2 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;width: 200px;">
          <app-jkedit [visible]="true" [required]="true" [(value)]="item.ps2">
          </app-jkedit>
        </td>
      </ng-container>

      <tr class="text-blue-800" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-tab>

  <mat-tab #myTabJson label="JSON明細">
    <app-json-editor [initialValue]="jsonData" [darkTheme]="isDarkTheme" (valueChange)="onValueChange($event)"
      (jsonChange)="onJsonChange($event)" (themeChange)="onThemeChange($event)">
    </app-json-editor>
  </mat-tab>
  <mat-tab #myTabApi label="API 介面">
    <div class="flex border">
      <app-jkcombobox class="jk-combobox-border" [width]="100" [styleDisplay]="'flex'" [(value)]="apiMethod"
        [items]="apiMethodList">
      </app-jkcombobox>
      <app-jkedit [visible]="true" [label]="''" [required]="true" [(value)]="apiUrl" [width]="'360'">
      </app-jkedit>
      <button (click)="doApiOk()" class="btn-primary">確定</button>
      <button (click)="doApiCancel()" class="btn-primary">取消</button>

    </div>
    <div>
      <app-json-editor [initialValue]="apiBody" [darkTheme]="isDarkTheme" (valueChange)="onValueChange($event)"
        (jsonChange)="onJsonChange($event)" (themeChange)="onThemeChange($event)">
      </app-json-editor>
      @if (hasError) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
      }
    </div>
  </mat-tab>

</mat-tab-group>

<!--
    <app-jkaggrid
      #myGrid
      [columnDefs]="columnDefs"
      [maxHeight]="1000"
      [minHeight]="300"
      [defaultHeight]="400"
      [height]="400"
      (afterGridReadyAg)="afterGridReady($event)"
    >
    </app-jkaggrid>
 -->
